import $api from "../api";
import $cookies from "vue-cookies";
import Swal from "sweetalert2";

export const state = {
    token: $cookies.get("token"),
    refreshToken: $cookies.get("refreshToken"),
    type: 1,
    id: 1,
    profile: {
        username: "",
        role: "",
        contact_number: "",
        total_wingband: "",
        date_registered: "",
        chapters: [],
    }
};

export const actions = {
    loginUser({ commit }, pl) {
        return new Promise(function (resolve) {
            $api.setLoggingIn(true);
            
            $api
                .post("auth/login", pl)
                .then(function (res) {
                    $api.setLoggingIn(false);
                    if (res.status === 200) {
                        resolve(res.data);
                        if (res.data.message == 'You are now logged in!') {
                            commit("setToken", res.data.data);
                            resolve(true);
                        }
                        else {
                            resolve(res.data);
                        }
                    }
                })
                .catch(function (err) {
                    $api.setLoggingIn(false);
                    if (err.response.status === 500) {
                        Swal.fire({
                            icon: "error",
                            html: ` Oops! Something went wrong on our end. <br><br>We're working to fix this as soon as possible. Please try again later. <br>If the issue persists, feel free to contact our <span class="fw-bold">Developer's team.</span>`,
                        });
                    }
                    else if (err.response.data.message == "ACCOUNT INACTIVE") {
                        Swal.fire({
                            icon: "error",
                            title: err.response.data.message,
                        });
                    } else if (err.response.data.message == "Invalid username or password") {
                        Swal.fire({
                            icon: "error",
                            title: "Invalid username or password"
                        })
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: err.response.data.message
                        })
                    }
                    resolve(false);
                });
        });
    },
    logoutUser({ commit, getters }) {
        return new Promise(function (resolve) {
            $api
                .get("auth/logout", {
                    headers: { Authorization: getters.bearer_token },
                })
                .then(function () {
                    commit("destroyAuth");
                    resolve(true);
                })
                .catch(function () {
                    commit("destroyAuth");
                    resolve(true);
                });
        });
    },
    refreshAccessToken({ commit, state }) {
        return new Promise(function (resolve, reject) {
            if (!state.refreshToken) {
                reject(new Error('No refresh token available'));
                return;
            }

            $api
                .post("auth/refresh", { refresh_token: state.refreshToken })
                .then(function (res) {
                    if (res.status === 200 && res.data.data) {
                        commit("updateTokens", res.data.data);
                        resolve(res.data.data);
                    } else {
                        reject(new Error('Invalid refresh response'));
                    }
                })
                .catch(function (err) {
                    console.warn('Refresh token failed:', err.response && err.response.status);
                    reject(err);
                });
        });
    },
    sessionExpired() {
        Swal.fire({
            title: "Session Expired",
            text: "Session expired, please retry.",
            icon: "warning",
            confirmButtonText: "OK",
        });
    },
    getProfile({ commit, getters }) {
        return new Promise(function (resolve) {
            if (!getters.bearer_token || getters.bearer_token === 'Bearer null') {
                resolve(null);
                return;
            }
            
            $api
                .get(`auth/profile`, {
                    headers: { Authorization: getters.bearer_token },
                }
                )
                .then(function (res) {
                    if (res.status === 200) {
                        commit("setProfile", res.data.data);
                    }
                    resolve(true);
                })
                .catch(function () {
                    resolve(null);
                });

        });
    },
    changePass({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .put(`auth/change-password`, pl, {
                    headers: {
                        Authorization: rootGetters["auth/bearer_token"],
                    },
                })
                .then(function (res) {
                    if (res.status == 200) {
                        resolve(res.data);
                    }
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                    if (err.response.status == 422) {
                        resolve(err.response.data);
                    } else {
                        resolve(err.response.data);
                    }
                });
        });
    },
};

export const mutations = {
    triggerLoader(state, value) {
        state.profile.loading = Boolean(value)
        state.profile.routeTo = value ? value : null
    },
    setToken(state, data) {
        var token = `${data.token_type} ${data.access_token}`;
        $cookies.set("token", token);
        
        if (data.refresh_token) {
            $cookies.set("refreshToken", data.refresh_token);
            state.refreshToken = data.refresh_token;
        }
        
        state.token = token;
        
        sessionStorage.setItem('loginTime', Date.now().toString());
        
        setTimeout(() => {
            window.location.reload();
        }, 1000);
    },
    updateTokens(state, data) {
        var token = `${data.token_type} ${data.access_token}`;
        $cookies.set("token", token);
        state.token = token;
        
        if (data.refresh_token) {
            $cookies.set("refreshToken", data.refresh_token);
            state.refreshToken = data.refresh_token;
        }
        
        sessionStorage.setItem('loginTime', Date.now().toString());
    },
    register() {
        this.$router.push({ path: "/login" });
    },
    setProfile(state, data) {
        state.profile.username = data.username;
        state.profile.role = data.role;
        state.profile.contact_number = data.contact_number;
        state.profile.total_wingband = data.total_wingband;
        state.profile.created_at = data.created_at;
        state.profile.chapters = data.chapters ?? [];
    },
    destroyAuth(state) {
        $cookies.remove("token");
        $cookies.remove("refreshToken");
        sessionStorage.removeItem('loginTime');
        
        state.token = null;
        state.refreshToken = null;
        
        state.profile.id = null;
        state.profile.username = null;
        state.profile.first_name = null;
        state.profile.last_name = null;
        state.profile.contact_number = null;
        state.profile.email_address = null;
        state.profile.role = null;
        state.profile.address = null;
        state.profile.birthday = null;
        state.profile.abilities = null;
        
        window.location.href = '/login';
    }
};

export const getters = {
    authenticated(state) {
        return state.token != null;
    },
    bearer_token(state) {
        return state.token ? `Bearer ${state.token}` : null;
    },
    hasRefreshToken(state) {
        return state.refreshToken != null;
    },
    profile(state) {
        return state.profile;
    },
    access(state) {
        var arr = [...state.access]
        if (state.access.includes("/user")) {
            arr.push("/role-management")
            arr.push("/company-management")
            arr.push("/department-management")
        }
        return arr
    },
};